import { Utils } from "../core/utils";
import { ScfPermission } from "./scf_auth_handler";

export class ScfOperations {
  constructor() {
    Utils.pageSanityHandler();
  }

  handler() {
    this.setActiveSidebar();
  }

  setActiveSidebar() {
    // Remove active class from all sidebar elements
    const allSidebarElements = document.querySelectorAll('.sidebar-element');
    allSidebarElements.forEach(element => {
      element.classList.remove('active');
    });

    // Add active class to operations sidebar element
    const operationsLink = document.querySelector('a[href="/scf/operations"]');
    if (operationsLink) {
      operationsLink.closest('.sidebar-element').classList.add('active');
    }
  }
}
